import { type FlowTestSuiteSaveOutcome, FlowTestSuiteSaveOutcomeSchema } from 'flow-schema';

import type { Common } from '../common.js';
import {
  FlowTestCasesGenerationRequestIdSchema,
  type FlowTestCasesGenerationRequestStatus,
  FlowTestCasesGenerationRequestStatusSchema,
  type FlowTestCasesRequest,
  FlowTestCasesRequestSchema,
  type StartFlowTestCasesGenerationResponse,
  StartFlowTestCasesGenerationResponseSchema,
} from '../models/flow/testCaseGeneration/testCaseGeneration.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/test-case-generation';

  constructor(common: Common) {
    this.common = common;
  }

  async start(args: FlowTestCasesRequest): Promise<StartFlowTestCasesGenerationResponse> {
    const request = FlowTestCasesRequestSchema.parse(args);
    const url = this.common.constructPath(`${this.baseEndpoint}/generate`);
    const response = await this.common.postJSON(url, request);
    return StartFlowTestCasesGenerationResponseSchema.parse(response);
  }

  async status(requestId: string): Promise<FlowTestCasesGenerationRequestStatus> {
    const parsedRequestId = FlowTestCasesGenerationRequestIdSchema.parse(requestId);
    const url = this.common.constructPath(`${this.baseEndpoint}/requests/${parsedRequestId}`);
    const response = await this.common.getJSON(url);
    return FlowTestCasesGenerationRequestStatusSchema.parse(response);
  }

  /** Returns the suite save outcome that generation recorded, saving first if it has not. */
  async save(requestId: string): Promise<FlowTestSuiteSaveOutcome> {
    const parsedRequestId = FlowTestCasesGenerationRequestIdSchema.parse(requestId);
    const url = this.common.constructPath(`${this.baseEndpoint}/requests/${parsedRequestId}/save`);
    const response = await this.common.postJSON(url, {});
    return FlowTestSuiteSaveOutcomeSchema.parse(response);
  }
}
